<template>
  <div class="section2-container">
    <div class="box">
      <div class="separator">
        <img src="@images/border-white.png" />
      </div>
      <div class="box-wrapper">
        <div class="row m-0">
          <div class="col-12 box-wrapper-col">
            <div class="image mt-0">
              <img src="@images/factory/04.jpg" alt="factory image" />
            </div>
            <div class="image mt-0">
              <img src="@images/about/03.jpg" alt="factory image" />
            </div>
            <div class="image mt-0">
              <img src="@images/about/01.jpg" alt="factory image" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
@import "@scss/about/section2.scss";
</style>